import React, { useEffect, useState } from "react";
import { Card, Statistic, Table, Row, Col } from "antd";
import { UserOutlined, FileTextOutlined, CommentOutlined, EyeOutlined } from "@ant-design/icons";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Bar, BarChart } from "recharts";
import api from "../api";
import { useTheme } from '../contexts/ThemeContext';
import "./dashboard.css";

const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { isDarkMode } = useTheme();

  const fetchDashboardData = async () => {
    try {
      const response = await api.get("/panel/dashboard");
      setDashboardData(response.data);
    } catch (error) {
      console.error("خطا در دریافت داده‌های داشبورد:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardData();
  }, []);

  if (loading) {
    return <div>در حال بارگذاری...</div>;
  }

  if (!dashboardData) {
    return <div>داده‌ای یافت نشد.</div>;
  }

  const {
    lastUser,
    onlineUser,
    offUser,
    monthPay,
    monthView,
    acceptComment,
    checkComment,
    lastPost, 
    lastComment,
    viewDay,
    viewYesterday,
    viewMonth,
    viewYear,
    viewWeek,
    lastThreeDaysPays,
  } = dashboardData;

  const payData = monthPay.map((value, index) => ({
    name: `برج ${index + 1}`,
    پرداخت: value,
  }));

  const viewData = monthView.map((value, index) => ({
    name: `برج ${index + 1}`,
    بازدید: value,
  }));

  const lastThreeDaysData = Object.keys(lastThreeDaysPays).map((date) => ({
    name: date,
    پرداخت: lastThreeDaysPays[date],
  }));


  const userColumns = [
    {
      title: "نام کاربر",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "ایمیل",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "تاریخ ثبت‌نام",
      dataIndex: "created_at",
      key: "created_at",
    },
  ];

  const postColumns = [
    {
      title: "عنوان پست",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "تاریخ ایجاد",
      dataIndex: "created_at",
      key: "created_at",
    },
  ];

  const commentColumns = [
    {
      title: "کاربر",
      dataIndex: ["user", "name"],
      key: "user",
    },
    {
      title: "نظر",
      dataIndex: "body",
      key: "body",
    },
    {
      title: "تاریخ ایجاد",
      dataIndex: "created_at",
      key: "created_at",
    },
  ];

  return (
    <div className="p-4">
      {/* <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={6}>
          <Card>
            <Statistic
              title="کاربران آنلاین"
              value={onlineUser}
              prefix={<UserOutlined className="text-blue-500" />}
              valueStyle={{ color: "#3b82f6" }}
              className={isDarkMode ? "dark-mode-statistic" : "light-mode-statistic"}
              />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card>
            <Statistic
              title="کاربران آفلاین"
              value={offUser}
              prefix={<UserOutlined className="text-gray-500" />}
              valueStyle={{ color: "#6b7280" }}
              className={isDarkMode ? "dark-mode-statistic" : "light-mode-statistic"}

            />
          </Card>
        </Col>

        <Col xs={24} sm={12} md={6}>
          <Card>
            <Statistic
              title="نظرات تایید شده"
              value={acceptComment}
              prefix={<CommentOutlined className="text-green-500" />}
              valueStyle={{ color: "#10b981" }}
              className={isDarkMode ? "dark-mode-statistic" : "light-mode-statistic"}

            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card>
            <Statistic
              title="نظرات در انتظار بررسی"
              value={checkComment}
              prefix={<CommentOutlined className="text-yellow-500" />}
              valueStyle={{ color: "#f59e0b" }}
              className={isDarkMode ? "dark-mode-statistic" : "light-mode-statistic"}

            />
          </Card>
        </Col>
      </Row> */}

      {/* <Row gutter={[16, 16]} className="mt-4">
        <Col xs={24} sm={12} md={6}>
          <Card>
            <Statistic
              title="بازدید امروز"
              value={viewDay}
              prefix={<EyeOutlined className="text-purple-500" />}
              valueStyle={{ color: "#8b5cf6" }}
              className={isDarkMode ? "dark-mode-statistic" : "light-mode-statistic"}

            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card>
            <Statistic
              title="بازدید دیروز"
              value={viewYesterday}
              prefix={<EyeOutlined className="text-indigo-500" />}
              valueStyle={{ color: "#6366f1" }}
              className={isDarkMode ? "dark-mode-statistic" : "light-mode-statistic"}

            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card>
            <Statistic
              title="بازدید این ماه"
              value={viewMonth}
              prefix={<EyeOutlined className="text-pink-500" />}
              valueStyle={{ color: "#ec4899" }}
              className={isDarkMode ? "dark-mode-statistic" : "light-mode-statistic"}

            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card>
            <Statistic
              title="بازدید این سال"
              value={viewYear}
              prefix={<EyeOutlined className="text-red-500" />}
              valueStyle={{ color: "#ef4444" }}
              className={isDarkMode ? "dark-mode-statistic" : "light-mode-statistic"}

            />
          </Card>
        </Col>
      </Row> */}

      <Card title="پرداخت‌های سه روز اخیر" className="mt-4">
  <ResponsiveContainer width="100%" height={300}>
    <BarChart
      data={lastThreeDaysData}
      margin={{ top: 20, right: 30, left: 20, bottom: 5 }} 
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="name" />
      <YAxis tickMargin={55} /> 
      <Tooltip />
      <Legend />
      <Bar
        dataKey="پرداخت"
        fill="#3b82f6"
        barSize={30} 
      />
    </BarChart>
  </ResponsiveContainer>
</Card>

      <Card title="پرداخت‌های ماهانه" className="mt-4">
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={payData} >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis tickMargin={55} />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="پرداخت" stroke="#3b82f6" activeDot={{ r: 8 }} />
          </LineChart>
        </ResponsiveContainer>
      </Card>

      {/* <Card title="بازدیدهای ماهانه" className="mt-4">
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={viewData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis tickMargin={40} />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="بازدید" stroke="#10b981" activeDot={{ r: 8 }} />
          </LineChart>
        </ResponsiveContainer>
      </Card> */}

      <Card title="آخرین کاربران" className="mt-4">
        <Table
          columns={userColumns}
          dataSource={lastUser}
          rowKey="id"
          pagination={false}
        />
      </Card>

      <Card title="آخرین پست‌ها" className="mt-4">
        <Table
          columns={postColumns}
          dataSource={lastPost}
          rowKey="id"
          pagination={false}
        />
      </Card>

      <Card title="آخرین نظرات" className="mt-4">
        <Table
          columns={commentColumns}
          dataSource={lastComment}
          rowKey="id"
          pagination={false}
        />
      </Card>
    </div>
  );
};

export default Dashboard;